module.exports = "<div class=\"alphabetical-filter__letter-block\"\n     ng-repeat=\"letter in $ctrl.letters\"\n     ui-sref=\"engineer.members.member-list({letter: letter})\"\n     ng-class=\"{'alphabetical-filter__letter-block--active': ($ctrl.$stateParams.letter === letter)}\">\n  {{letter}}\n</div>\n"


//////////////////
// WEBPACK FOOTER
// ./src/app/screens/engineer/screens/members/screens/member-list/components/alphabetical-filter/alphabetical-filter.html
// module id = 320
// module chunks = 0